import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
const a = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M12.853 6.097a.5.5 0 0 1 0 .707l-4.5 4.5a.5.5 0 0 1-.707 0l-4.5-4.5a.5.5 0 0 1 .708-.707L8 10.243l4.146-4.146a.5.5 0 0 1 .707 0Z" }) }), l = s.forwardRef(a);
export {
  l as F
};
//# sourceMappingURL=ChevronDown16.BcSr2mQh.js.map
